import { 
	TileTitle,
	TileDescription,
	IconWrapper,
	ContentWrapper,
	StyledUpgradePagesTile,	
} from './UpgradePagesTile.styled';
import { Icon, IconName } from '../icon';

interface Props {
  icon: string;
  tileTitle: string;
  tileDescription: string;
  isFullWidth?: boolean;
  isHorizontal?: boolean;
  canHover?: boolean;
}

export const UpgradePagesTile = ({ 
	icon, 
	tileTitle,
	tileDescription,
	isFullWidth = false,
	isHorizontal = false,
	canHover = false,
}: Props) => {
	return (
		<StyledUpgradePagesTile 
			$isFullWidth={isFullWidth}
			$isHorizontal={isHorizontal} 
			$canHover={canHover}
		>
			<IconWrapper 
				$isHorizontal={isHorizontal}
			>
				<Icon icon={icon as IconName} />
			</IconWrapper>
			<ContentWrapper 
				$isHorizontal={isHorizontal}
			>
				<TileTitle>{tileTitle}</TileTitle>
				<TileDescription>{tileDescription}</TileDescription>
			</ContentWrapper>
		</StyledUpgradePagesTile>
	);
};
